import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule,ReactiveFormsModule} from '@angular/forms';
import {QuestionnaireProjectComponent} from './questionnaire-project.component';
import {ProjectService} from '../project.service';
import {RespondentsModule } from '../../respondents/respondents.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,RespondentsModule

    ],
    declarations: [
        QuestionnaireProjectComponent

    ],
    providers: [
        ProjectService
    ],
    exports: [
        QuestionnaireProjectComponent

   ]
})
export class QuestionnaireProjectModule {

}


